<template>
  <div><CornerstoneTest/></div>
</template>

<script>
import CornerstoneTest from './views/CornerstoneTest.vue'

export default {
  name: 'App',
  components: {
    CornerstoneTest
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
